import { createContext } from "react";
import { IRecord, RecordState } from "../interfaces/interfaces";

export type CartContextProps = {
  recordState: RecordState;
  getRecords: (records: IRecord[]) => void;
  getDeletedRecords: (records: IRecord[]) => void;
  addRecord: (record: IRecord) => void;
  addDeletedRecord: (record: IRecord) => void;
  editRecord: (record: IRecord) => void;
  addEditForm: (record: IRecord) => void;
  deleteRecord: (record: IRecord) => void;
  restoreRecord: (record: IRecord) => void;
};

export const CartContext = createContext<CartContextProps>(
  {} as CartContextProps
);
